import React from "react";

export default ({ className, onClick, disabled = false, color = null }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    className={`${className || ""} ${disabled ? "disabled" : ""}`}
    onClick={disabled ? null : onClick}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 0C10.4477 0 10 0.447715 10 1V11C10 11.5523 10.4477 12 11 12C11.5523 12 12 11.5523 12 11V1C12 0.447715 11.5523 0 11 0ZM1.57668 10.887C0.91427 11.3546 0 10.8809 0 10.0701V1.92992C0 1.1191 0.91427 0.645367 1.57668 1.11295L7.34263 5.18303C7.90705 5.58145 7.90705 6.41855 7.34263 6.81697L1.57668 10.887Z"
      fill={color ? color : disabled ? "#4D4D4D" : "#fff"}
    />
  </svg>
);
